import * as RadixPopover from '@radix-ui/react-popover';
import classNames from 'classnames';
import { memo } from 'react';

import { Close as CloseIcon } from '@air/next-icons';
import { VisuallyHidden } from '@air/primitive-visually-hidden';

export type PopoverCloseButton = RadixPopover.PopoverCloseProps;

export const PopoverCloseButton = memo(({ className, ...restOfProps }: PopoverCloseButton) => {
  return (
    <RadixPopover.Close
      className={classNames(
        'flex h-6 w-6 items-center justify-center rounded-4 border-0 bg-transparent text-grey-12 outline-none hover:bg-pigeon-4 focus-visible:ring-2 focus-visible:ring-blue-9 active:bg-grey-4',
        className,
      )}
      {...restOfProps}
    >
      <VisuallyHidden>Close popover</VisuallyHidden>
      <CloseIcon className="size-4" />
    </RadixPopover.Close>
  );
});

PopoverCloseButton.displayName = 'PopoverCloseButton';
